export default function ProductoHeader({ producto, precioBase, editando }) {
  return (
    <div>
      <h1 className="text-2xl font-bold text-orange-400">
        {producto.nombre}
      </h1>

      <p className="text-orange-400 text-lg">
        ${precioBase.toLocaleString("es-CO")}
      </p>

      {editando && (
        <p className="text-xs text-gray-400 mt-1">
          Editando producto del carrito
        </p>
      )}
    </div>
  );
}
